import { createTheme } from '@mui/material/styles';

declare module '@mui/material/styles' {
  interface Palette {
    sidebar: {
      background: string;
      text: string;
      textSecondary: string;
      activeBackground: string;
      activeText: string;
      hoverBackground: string;
    };
    brand: { main: string };
  }
  interface PaletteOptions {
    sidebar?: {
      background: string;
      text: string;
      textSecondary: string;
      activeBackground: string;
      activeText: string;
      hoverBackground: string;
    };
    brand?: { main: string };
  }
}

const theme = createTheme({
  palette: {
    primary: {
      main: '#5E8AB4',
      light: '#B4D0E1',
      dark: '#3F5D7A',
      contrastText: '#fff',
    },
    secondary: {
      main: '#1E73BE',
      light: '#B4D0E1',
      dark: '#3F5D7A',
    },
    error: {
      main: '#F05F5E',
    },
    warning: {
      main: '#FFA267',
    },
    success: {
      main: '#60B8B0',
    },
    info: {
      main: '#4E8780',
    },
    background: {
      default: '#F2F2F3',
      paper: '#ffffff',
    },
    text: {
      primary: '#404040',
      secondary: '#828387',
    },
    sidebar: {
      background: '#3F5D7A',
      text: '#EFEAE1',
      textSecondary: '#B4D0E1',
      activeBackground: 'rgba(255, 255, 255, 0.15)',
      activeText: '#ffffff',
      hoverBackground: 'rgba(255, 255, 255, 0.1)',
    },
    brand: {
      main: '#424E7A',
    },
  },
  typography: {
    fontFamily: ['Poppins', 'Avenir', '-apple-system', 'BlinkMacSystemFont', '"Roboto"', '"Helvetica"', '"Arial"', 'sans-serif'].join(','),
    h1: {
      fontSize: '26px',
      fontWeight: 700,
      color: '#404040',
      '@media (max-width:600px)': {
        fontSize: '22px',
      },
    },
    h2: {
      fontSize: '20px',
      fontWeight: 600,
      color: '#404040',
      '@media (max-width:600px)': {
        fontSize: '18px',
      },
    },
    h3: {
      fontSize: '18px',
      fontWeight: 600,
      color: '#404040',
    },
    h4: {
      color: '#404040',
      fontSize: '14px',
    },
    h5: {
      color: '#404040',
      fontSize: '14px',
    },
    h6: {
      color: '#404040',
      fontSize: '14px',
    },
    subtitle1: {
      fontSize: '14px',
      color: '#5E8AB4',
      marginBottom: '4px',
    },
    subtitle2: {
      color: '#5E8AB4',
      fontSize: '10px',
      textDecoration: 'none',
    },
    body1: {
      fontSize: '15px',
      color: '#404040',
    },
    body2: {
      fontSize: '14px',
      color: '#828387',
    },
    button: {
      fontSize: '14px',
      fontWeight: 500,
      boxShadow: 'none',
      height: '40px',
      textTransform: 'none',
    },
    caption: {
      fontSize: '12px',
      color: '#828387',
    },
    overline: {
      fontSize: '14px',
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
          '&:hover': { boxShadow: 'none' },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
          maxWidth: '100%',
        },
      },
    },
    // Phones only: 16px margins and nearly the full width. Applied on every
    // screen size (May 2026) it lifted MUI's maxWidth cap off every dialog,
    // so a dialog sized "sm" or "md" stretched nearly full width on desktop.
    MuiDialog: {
      styleOverrides: {
        paper: {
          '@media (max-width: 599.95px)': {
            margin: 16,
            maxWidth: 'calc(100% - 32px)',
          },
        },
      },
    },
  },
});

export default theme;
